import React, { useState } from "react";
import MainCalculatorsList from './MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { SecondAds, FirstAds, MobileUnderCalAds } from '../../Ads';
import { SERVER_URL } from './ConstantsWomenCalculator';
import { Ovulation_EndPoint } from './ConstantsWomenCalculator';
import { OvulationTableFull } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = 'Calculatrice d\'ovulation - Calculer les jours d\'ovulation et de rapports sexuels';
const DESCRIPTION =
  "Calculatrice d\\ pour obtenir des estimations utiles en sante feminine et suivi du cycle. Entrez vos informations et recevez des resultats rapides pour mieux planifier.";
const KEYWORDS =
  "d\\, calculatrice d\\, calcul en ligne, sante feminine, cycle, grossesse, resultat rapide";
const OG_URL = 'https://do-calculate.com/calculator/fr/ovulation/';
const apiEndpoint = `${SERVER_URL}/${Ovulation_EndPoint}`;
function OvulationCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [periodLength, setPeriodLength] = useState(1);
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateOvulation = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength, periodLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b>
                        <h1 style={{ fontSize: '15px' }}>   Calculatrice d'ovulation | Comment calculer les jours d'ovulation et les chances de grossesse
                        </h1>
                    </b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                La calculatrice d'ovulation est utilisée pour déterminer les jours d'ovulation chez la femme, qui sont les jours qui représentent la période de fertilité optimale, au cours de laquelle les chances de grossesse augmentent considérablement. Les dates des règles et les durées du cycle menstruel varient entre les femmes, ce qui entraîne une variation dans la période d'ovulation et la fenêtre de fertilité d'une femme à l'autre. Dans un cycle menstruel standard de 28 jours, la période d'ovulation commence généralement environ 14 jours après le premier jour du cycle menstruel. Il est à noter que la fenêtre de fertilité s'étend généralement sur environ cinq jours avant l'ovulation et trois jours après, au cours desquels les chances de grossesse sont à leur maximum.
                            </div>
                            <div>
                                La calculatrice de période d'ovulation et de fertilité est un outil important qui vous aide à découvrir les moments où votre fertilité est à son maximum, ce qui double vos chances de grossesse. Entrez simplement les informations requises pour obtenir une estimation précise de votre période d'ovulation et de votre fenêtre de fertilité.
                            </div>
                            <hr />
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>   Calculatrice des jours d'ovulation </h2>
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label" style={{marginRight: "10px"}}>
                                        <strong>Premier jour</strong> de vos dernières règles:
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label" style={{marginRight: "10px"}}>
                                        Durée moyenne entre les cycles
                                    </label>
                                    </b>
                                    <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">jours</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateOvulation}>Calculer </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Erreur :</u></b> Veuillez entrer tous les champs correctement. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Résultats: </div></h4>
                                            <hr />
                                            <OvulationTableFull result={result}></OvulationTableFull>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <strong>Comment la grossesse se produit chez la femme</strong>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    La grossesse se produit chez la femme lorsque le sperme de l'homme féconde l'ovule mature qui sort de l'ovaire de la femme pendant la période d'ovulation. Cet ovule dure très peu longtemps, entre 12 et 24 heures. Pour qu'une grossesse se produise, le rapport sexuel doit avoir lieu au moment de l'ovulation, lorsque les chances de grossesse sont les plus élevées. La calculatrice d'ovulation est utilisée pour déterminer cette période optimale, ce qui aide à la planification familiale ou à augmenter les chances de grossesse.
                                </p>
                                <p>
                                    <strong>Ovulation et fécondation:</strong> Chez les humains, l'ovulation est le processus au cours duquel l'ovule mature est libéré de l'ovaire. L'ovulation se produit généralement 14 jours avant le début du prochain cycle menstruel. À l'aide d'une calculatrice d'ovulation, les jours les plus fertiles peuvent être prédits. La période entre le jour 10 et le jour 18 du cycle menstruel est la plus susceptible de connaître une ovulation. Au cours de cette période, les spermatozoïdes peuvent rester dans le système reproducteur de la femme pendant jusqu'à cinq jours, augmentant les chances de grossesse.
                                </p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <strong>Prédiction de l'ovulation</strong>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    La calculatrice d'ovulation est un outil important pour prédire les jours de menstruation et les jours d'ovulation les plus probables. La calculatrice dépend de la connaissance du premier jour du cycle menstruel et de la durée du cycle menstruel. En utilisant ces informations, les jours d'ovulation peuvent être calculés avec précision, ce qui aide la femme à déterminer le meilleur moment pour avoir des relations sexuelles pour réaliser ou éviter une grossesse. Cette prédiction aide à augmenter les chances de grossesse si désiré.
                                </p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <strong>Méthode de calcul des jours d'ovulation</strong>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    La période d'ovulation dure généralement entre 12 et 24 heures. Bien qu'il soit difficile de déterminer cette période avec une précision absolue, la calculatrice d'ovulation est utilisée pour estimer le meilleur moment. Le processus dépend du calcul de l'intervalle entre les règles, puis en ajoutant cette période à la date du premier jour des dernières règles. Par la suite, deux semaines sont soustraites de la date prévue, en tenant compte de cinq jours avant et deux jours après cette date comme période approximative d'ovulation. La calculatrice d'ovulation aide à déterminer cette période avec précision, ce qui facilite la connaissance des jours les plus appropriés pour une grossesse.
                                </p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <strong>Programme de calcul des jours d'ovulation</strong>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    Le programme de la calculatrice des jours d'ovulation est un outil basé sur les données saisies concernant la date du premier jour des dernières règles et la durée du cycle menstruel. Le programme fournit des informations précises sur la période d'ovulation, aidant les femmes à déterminer les jours les plus susceptibles de produire une grossesse au cours des rapports sexuels. La calculatrice d'ovulation peut être utilisée selon le calendrier grégorien ou hégérien, offrant flexibilité et précision dans le calcul de la période d'ovulation.
                                </p>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <strong>Utilisation de la calculatrice d'ovulation</strong>
                            </div>
                            <div className="info-section-body">
                                <p>
                                    Pour utiliser la calculatrice d'ovulation, la femme doit connaître la date du premier jour des dernières règles et la durée du cycle menstruel. En saisissant ces informations dans la calculatrice, la période d'ovulation peut être calculée facilement et avec précision en quelques secondes. Ce calcul est fondamental pour augmenter les chances de grossesse ou pour planifier la famille de manière naturelle.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default OvulationCalculator;
